import React from 'react';
import PrivateRoute from './PrivateRoute';

interface SuperAdminRouteProps {
  children: React.ReactNode;
}

/**
 * Composant de route protégée réservée au Super Administrateur.
 * Redirige vers la page de connexion si l'utilisateur n'est pas super_admin.
 * Modules concernés : Splits QR, Campagnes QR Code, Logs Système.
 */
const SuperAdminRoute: React.FC<SuperAdminRouteProps> = ({ children }) => {
  return (
    <PrivateRoute requiredRole="super_admin">
      {children}
    </PrivateRoute>
  );
};

export default SuperAdminRoute;
